import * as SmallCustomIcon from './SmallCustomIcon';
import * as MediumCustomIcon from './MediumCustomIcon';
import * as LargeCustomIcon from './LargeCustomIcon';


export const CustomIcon = {
  large: LargeCustomIcon,
  medium: MediumCustomIcon,
  small: SmallCustomIcon
};

export type LargeIconType = LargeCustomIcon.IconTypes;
export type MediumIconType = MediumCustomIcon.IconTypes;
export type SmallIconType = SmallCustomIcon.IconTypes;
